const isClient = typeof window !== 'undefined';

export const safeWindow = isClient
  ? window
  : {
      localStorage: {
        getItem: () => null,
        setItem: () => {},
        removeItem: () => {},
        clear: () => {},
      },
      sessionStorage: {
        getItem: () => null,
        setItem: () => {},
        removeItem: () => {},
        clear: () => {},
      },
      location: {
        href: '',
        pathname: '',
      },
      document: {},
    };

export default safeWindow;
